export enum JobClosureOutcomeEnum {
  HiredFromHuro = 'HiredFromHuro',
  HiredOutsideHuro = 'HiredOutsideHuro',
  NotHired = 'NotHired',
  // TODO: backend support pending
  Other = 'Other'
}

export const JOB_CLOSURE_OUTCOME_DISPLAY: Record<
  JobClosureOutcomeEnum,
  string
> = {
  [JobClosureOutcomeEnum.HiredFromHuro]: 'Hired a Huro Professional',
  [JobClosureOutcomeEnum.HiredOutsideHuro]: 'Hired outside of Huro',
  [JobClosureOutcomeEnum.NotHired]: 'Did not hire anyone',
  [JobClosureOutcomeEnum.Other]: 'Other'
};
